import { useState, type JSX } from "react";

import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerForm from "ds/components/DrawerNew/Form";

type SettingsSingleSignOnDrawerProps = {
  children: ({ setIsDirty }: { setIsDirty: (isDirty: boolean) => void }) => JSX.Element;
  isDismissable?: boolean;
};

const SettingsSingleSignOnDrawer = createDrawer(function SingleSignOnSetupDrawer({
  children,
  isDismissable,
}: SettingsSingleSignOnDrawerProps) {
  const [isDirty, setIsDirty] = useState(false);

  return (
    <DrawerForm isDirty={isDirty} isDismissable={isDismissable}>
      {children({ setIsDirty })}
    </DrawerForm>
  );
});

export const openSingleSignOnDrawer = createDrawerTrigger(SettingsSingleSignOnDrawer);
